<template>
  <div class="tugas">
    <div class="header">
      <h3>Pekerjaan Saya</h3>
      <div @click="openSearch()">
        <search v-show="!searchOpen" />
        <close v-show="searchOpen" />
      </div>

      <div class="search" :class="{ active: searchOpen }">
        <input
          type="text"
          ref="input_search"
          placeholder="Cari judul pekerjaan"
          v-model="keyword"
          @input="handleInput"
        />
      </div>
    </div>

    <div class="body">
      <div class="tab">
        <div style="margin-bottom: 10px" v-if="$user.access == 'ADMIN'">
          <small style="display: block; margin-bottom: 6px">Filter User</small>
          <div>
            <select v-model="filter.user" @change="loadData('TODO')">
              <option
                v-for="(item, index) in user"
                :key="index"
                :value="item.id"
              >
                {{ item.nama }}
              </option>
            </select>
          </div>
        </div>

        <small style="display: block; margin-bottom: 6px" v-show="!keyword"
          >Filter Status</small
        >
        <p style="font-size: 14px" v-show="keyword">
          Pencarian: <b>{{ keyword }}</b>
        </p>
        <ul v-show="!keyword">
          <li :class="{ active: status == 'TODO' }" @click="loadData('TODO')">
            Todo ({{ summary.TODO }})
          </li>
          <li
            :class="{ active: status == 'IN_PROGRESS' }"
            @click="loadData('IN_PROGRESS')"
          >
            In Progress ({{ summary.IN_PROGRESS }})
          </li>
          <li
            :class="{ active: status == 'COMPLETE' }"
            @click="loadData('COMPLETE')"
          >
            Complete ({{ summary.COMPLETE }})
          </li>
        </ul>
      </div>

      <div class="task">
        <div class="skeleton-wrapper" v-show="loading">
          <div
            class="skeleton"
            v-for="(item, index) in [1, 1, 1, 1, 1]"
            :key="index"
          ></div>
        </div>
        <ul v-show="!loading">
          <li
            v-for="(item, index) in data"
            :key="index"
            :class="
              item.status == 'COMPLETE'
                ? 'complete'
                : item.diff < 0 && item.status != 'COMPLETE'
                ? 'danger'
                : item.diff <= 3 && item.status != 'COMPLETE'
                ? 'warning'
                : ''
            "
            @click="to('/detail/' + item.id + '?editable=true')"
          >
            <div>
              <p>{{ item.nama }}</p>

              <small v-show="item.status == 'COMPLETE'">
                Selesai pada {{ moment(item.complete_at).format("DD/MM/YY") }}
              </small>

              <small v-show="item.diff > 0">{{
                Math.abs(item.diff) + " hari lagi"
              }}</small>
              <small
                class="red"
                v-show="item.diff < 0 && item.status != 'COMPLETE'"
              >
                {{
                  "Target selesai pada tanggal " +
                  moment(item.tgl_target).format("DD/MM/YY")
                }}
              </small>
            </div>
            <div>
              <span class="badge" :class="item.status.toLowerCase()">{{
                item.status.replace("_", " ").toLowerCase()
              }}</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="fab">
        <router-link to="/add?editable=true">
          <span>+</span> Pekerjaan Baru
        </router-link>
      </div>
    </div>

    <div
      class="overlay"
      :class="{ show: searchOpen }"
      @click="closeSearch()"
    ></div>
  </div>
</template>

<script>
import moment from "moment";
import { debounce } from "lodash";

import * as api from "./../api/Api";

import Loading from "./icons/Loading";
import Search from "./icons/Search";
import Add from "./icons/Add";
import Close from "./icons/CloseOutline";

export default {
  name: "Task",
  components: {
    Search,
    Add,
    Close,
    Loading,
  },
  data() {
    return {
      status: localStorage.getItem("last_status")
        ? localStorage.getItem("last_status")
        : "TODO",
      loading: false,
      searchOpen: false,
      data: [],
      user: [],
      summary: {
        TODO: 0,
        IN_PROGRESS: 0,
        COMPLETE: 0,
      },
      keyword: "",

      filter: {
        user: "",
      },
    };
  },
  methods: {
    moment,
    loadData(status) {
      this.loading = true;
      this.status = status;
      this.keyword = "";

      let param = "";

      if (this.$user.access == "ADMIN") {
        param = "id_user=" + this.filter.user;
      } else {
        param = "id_user=" + this.$user.id;
      }
      param += "&status=" + this.status;

      api
        .get("/v1/kendali_kerja/pekerjaanController/get?" + param)
        .then((r) => {
          localStorage.setItem("last_status", status);

          setTimeout(() => {
            this.loading = false;
            if (r.valid) {
              this.data = r.data;

              // reset summary
              this.summary = {
                TODO: 0,
                IN_PROGRESS: 0,
                COMPLETE: 0,
              };

              r.summary.forEach((item) => {
                this.summary[item.status] = item.total;
              });
            }
          }, 150);
        });
    },
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    openSearch() {
      this.searchOpen = !this.searchOpen;

      if (this.searchOpen !== false) {
        setTimeout(() => {
          this.$refs["input_search"].focus();
        }, 150);
      } else {
      }
    },
    closeSearch() {
      this.searchOpen = false;
    },
    handleInput() {
      // Membatalkan timeout sebelumnya (jika ada)
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      // Menjalankan logika dengan waktu jeda 300 milidetik
      this.timeout = setTimeout(() => {
        // Logika yang akan dijalankan setelah waktu jeda

        if (this.keyword) {
          let param = "id_user=" + this.$user.id + "&keyword=" + this.keyword;

          if (this.$user.access == "ADMIN") {
            param = "id_user=" + this.filter.user + "&keyword=" + this.keyword;
          }

          this.loading = true;
          this.searchOpen = false;

          api
            .get("/v1/kendali_kerja/pekerjaanController/filter?" + param)
            .then((r) => {
              this.data = r.data;
              this.loading = false;
            });
        } else {
          this.loadData("TODO");
        }

        this.timeout = null; // Mengatur timeout kembali menjadi null setelah selesai
      }, 500);
    },
  },
  mounted() {
    if (this.$user.access == "ADMIN") {
      this.user = this.$store.state.user.data;

      if (this.$route.query.id_user) {
        this.filter.user = this.$route.query.id_user;
      } else {
        this.filter.user = this.$user.id;
      }

      if (this.$route.query.status) {
        this.status = this.$route.query.status;
      }
    }

    this.loadData(this.status);
  },
};
</script>

<style scoped lang="scss">
.tugas {
  padding: 20px;

  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    left: calc(50% - 240px);
    width: 440px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    padding: 15px 20px;
    background: #fff;

    @media screen and (max-width: 768px) {
      left: 0;
      width: calc(100% - 40px);
    }

    h3 {
      margin: 0;
    }
    .icon {
      height: 26px;
    }
    .search {
      flex: 100%;
      height: 0;
      opacity: 0;
      transition: all 0.3s ease;

      input {
        margin-top: 10px;
      }

      &.active {
        height: 50px;
        opacity: 1;
      }
    }
  }

  .body {
    padding-top: 50px;
    padding-bottom: 100px;
    .task {
      padding: 0;

      .loading {
        display: flex;
        justify-content: center;
        padding: 50px 0;
      }
    }

    .fab {
      position: fixed;
      bottom: 80px;
      right: calc(50% - 220px);

      @media screen and (max-width: 768px) {
        right: 20px;
      }

      a {
        background-color: #0588ff;
        color: #fff;
        padding: 5px 26px 5px 20px;
        border-radius: 60px;
        text-decoration: none;
        box-shadow: 0px 3px 3px #ccc;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 15px;

        span {
          font-size: 28px;
        }
      }
    }
  }

  .tab {
    margin-bottom: 20px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      gap: 6px;

      li {
        padding: 10px 12px;
        border-bottom: 2px solid #fff;
        text-align: center;
        font-size: 14px;
        transition: all 0.3s ease;
        &.active {
          background: #0588ff;
          color: #fff;
          border-radius: 50px;
        }
        &:active {
          background-color: #eee;
        }
      }
    }
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.3);
    visibility: hidden;
    opacity: 0;
    transition: all 0.6s ease;
    &.show {
      opacity: 1;
      visibility: visible;
    }
  }
}

.skeleton-wrapper {
  .skeleton {
    min-height: 65px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Task.vue